module.exports = __webpack_public_path__ + "img/Daily-Downloads-of-Selected-Packages-1-300x257.f6e9d828.png";